import { useState } from "react"
import Header from "../components/Header"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"

import { Outlet, Link } from "react-router-dom"
const tab_items = [
	{ name: "Escribenos", url: "escribenos" },
	{ name: "Otros Clubs", url: "otrosclubs" },
	{ name: "Jugadores", url: "jugadores" },
]
function ContactPage() {
	const [tab_value, setValue] = useState(0)

	const handleChange = (event, newValue) => {
		setValue(newValue)
	}
	return (
		<div className="content">
			<Header title="Contacto" />

			<Tabs
				// disable the tab indicator because it doesn't work well with wrapped container
				TabIndicatorProps={{ sx: { display: "none" } }}
				sx={{
					"& .MuiTabs-flexContainer": {
						flexWrap: "wrap",
					},
				}}
				value={tab_value}
				onChange={handleChange}
				centered
			>
				{tab_items.map((tab) => (
					<Tab label={tab.name} component={Link} to={tab.url} />
				))}
			</Tabs>
			<br></br>

			<Outlet />
		</div>
	)
}

export default ContactPage
